module.exports = __webpack_public_path__ + "img/savanta.d8c7e3e2.png";